import { render, staticRenderFns } from "./AutoSaver.vue?vue&type=template&id=3efb9414&"
import script from "./AutoSaver.vue?vue&type=script&lang=js&"
export * from "./AutoSaver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AutoSaver.vue"
export default component.exports